module.exports = __webpack_public_path__ + "img/arrow-right.bea7e136.svg";